import { useEffect, useState } from "react";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 900px)").matches
  );

  useEffect(() => {
    const mediaQueryHandler = (event) => {
      setIsMobile(event.matches);
    };

    const mql = window.matchMedia("(max-width: 900px)");
    mql.addEventListener("change", mediaQueryHandler);

    return () => {
      mql.removeEventListener("change", mediaQueryHandler);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
